import { render, staticRenderFns } from "./DataCollectionSummaryTab.vue?vue&type=template&id=e9f31050"
import script from "./DataCollectionSummaryTab.vue?vue&type=script&lang=ts"
export * from "./DataCollectionSummaryTab.vue?vue&type=script&lang=ts"
import style0 from "./DataCollectionSummaryTab.vue?vue&type=style&index=0&id=e9f31050&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports